import {
  RowDataObject,
  RowScopedErrorsState,
  RowData,
  RowDataReducerState,
  RowDataReducerActionPayload,
} from "../../../types";

export const deleteObjectRowAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey, rowIndex, selectedTabSectionKey } = payload;
  if (!propertyKey || rowIndex === undefined) return state;

  if (selectedTabSectionKey) {
    return deleteNestedObjectRow(
      propertyKey,
      rowIndex,
      selectedTabSectionKey,
      state,
    );
  }

  return deleteObjectRow(propertyKey, rowIndex, state);
};

const deleteNestedObjectRow = (
  propertyKey: string,
  rowIndex: number,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray = (state.rowData[selectedTabSectionKey] as RowData)?.[
    propertyKey
  ] as RowDataObject[];
  const updatedArray =
    currentArray.filter((_, index) => index !== rowIndex) ?? [];

  const currentErrors =
    (state.rowDataErrors[propertyKey] as RowScopedErrorsState) || {};
  const updatedErrors = Object.fromEntries(
    Object.entries(currentErrors).filter(
      ([key]) => key !== rowIndex.toString(),
    ),
  );

  const updatedRowData = {
    ...state.rowData,
    [selectedTabSectionKey]: {
      ...(state.rowData[selectedTabSectionKey] as RowData),
      [propertyKey]: updatedArray,
    },
  } as RowData;

  const updatedRowDataErrors = {
    ...state.rowDataErrors,
    [propertyKey]: updatedErrors,
  };

  return {
    ...state,
    rowData: updatedRowData,
    rowDataErrors: updatedRowDataErrors,
  };
};

const deleteObjectRow = (
  propertyKey: string,
  rowIndex: number,
  state: RowDataReducerState,
): RowDataReducerState => {
  const currentArray = state.rowData[propertyKey] as RowDataObject[];
  const updatedArray =
    currentArray?.filter((_, index) => index !== rowIndex) ?? [];

  const currentErrors =
    (state.rowDataErrors[propertyKey] as RowScopedErrorsState) || {};
  const updatedErrors = Object.fromEntries(
    Object.entries(currentErrors).filter(
      ([key]) => key !== rowIndex.toString(),
    ),
  );

  const updatedRowData = {
    ...state.rowData,
    [propertyKey]: updatedArray,
  } as RowData;

  const updatedRowDataErrors = {
    ...state.rowDataErrors,
    [propertyKey]: updatedErrors,
  };

  return {
    ...state,
    rowData: updatedRowData,
    rowDataErrors: updatedRowDataErrors,
  };
};
